// THIS IS A GENERATED FILE, DO NOT EDIT
import { __assign } from "tslib";
import * as React from 'react';
import { Icon } from '../Icon';
export default React.forwardRef(function Envelope(props, ref) {
    return (React.createElement(Icon, __assign({}, props, { name: "Envelope" }),
        React.createElement("svg", { width: "24", height: "24", viewBox: "0 0 24 24", fill: "currentColor", xmlns: "http://www.w3.org/2000/svg", ref: ref },
            React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M21 5H3V6.50002L12.0109 12.7083L21 6.50002V5ZM21 8.7211L11.9892 14.8636L3 8.47877V19H21V8.7211Z", fill: "currentColor" }))));
});
//# sourceMappingURL=Envelope.js.map